module.exports = __webpack_public_path__ + "img/mt7.35c06b95.jpg";